import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useState } from "react";
import TextField from "@mui/material/TextField";
import { EditUpdateBehavior, useControlledTextEdit, useCsAttribute, } from "@plansoft-configuration-renderer/framework";
import { ControlLayoutContext, } from "@plansoft-configuration-renderer/layout";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
import { useAttributeInlineLabel } from "../../Attributes/useAttributeInlineLabel";
export function useColorPickerLayoutProps() {
    const baseProps = useContext(ControlLayoutContext);
    // case and set defaults
    const _a = baseProps, { disableAlpha = false, disablePalette = false, fullWidth = false, inlineLabel = false, custom = {} } = _a, restProps = __rest(_a, ["disableAlpha", "disablePalette", "fullWidth", "inlineLabel", "custom"]);
    return Object.assign({ disableAlpha,
        disablePalette,
        fullWidth,
        inlineLabel,
        custom }, restProps);
}
/**
 * Color picker (draft)
 * @returns
 */
export function ColorPicker() {
    const { value, handleChange, handleBlur } = useControlledTextEdit({
        debounceDelay: 500,
        updateBehavior: EditUpdateBehavior.OnBlur,
    });
    const { fullWidth } = useColorPickerLayoutProps();
    const { labelText } = useAttributeInlineLabel();
    const attribute = useCsAttribute();
    const t = useUiTranslator();
    const validateRegEx = "^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$";
    const [isError, setIsError] = useState(false);
    const isDisabled = Boolean(!attribute.isAllowed);
    const isReadOnly = Boolean(attribute.isReadOnly);
    const validateValue = useCallback((value) => {
        if (value.match(validateRegEx)) {
            setIsError(false);
        }
        else {
            setIsError(true);
        }
    }, [validateRegEx]);
    return (_jsx(TextField, { error: isError, helperText: isError
            ? t("ConfigurationRenderer:ColorPicker.invalidColorCode", "Invalid HEX color code")
            : undefined, required: attribute.isRequired, disabled: isDisabled || isReadOnly, fullWidth: fullWidth, label: labelText, type: "text", value: value, onChange: (e) => {
            validateValue(e.currentTarget.value);
            handleChange(e);
        }, onBlur: handleBlur, slotProps: {
            htmlInput: {
                pattern: validateRegEx,
            },
        } }));
}
// compatibility export
export { ColorPicker as Color };
//# sourceMappingURL=ColorPicker.js.map